export default __webpack_public_path__ + "static/media/unit.dc4c6ad6.png";